import React from "react";

import { useHistory } from "react-router-dom";
import { valueToString } from "helpers/Helpers";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function SalesByDepartmentTable(props: IProps) {
  const history = useHistory();

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string) {
    return formatDisplay(displayType, cellValue);
  }

  function rowClassNames(row: any) {
    return classNames({
      "report-table-row": row.original.type === "product" || !row.original.type,
      "report-table-row-department": row.original.type === "department",
      "report-table-row-category": row.original.type === "category",
      "report-table-row-subcategory": row.original.type === "subcategory",
    });
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
    });
  }

  // Add on click events based on column
  function cellOnClick(cell: any) {
    return {};
  }

  // Add footer data based on column
  function footerData(columnId: string) {
    switch (columnId) {
      case "sales_quantity":
        return getTotal(columnId, "number");
      case "sales_discount":
      case "sales_subtotal":
      case "sales_tax":
      case "sales_total":
        return getTotal(columnId, "currency");
      default:
        return null;
    }
  }

  function getTotal(columnId: string, type: string): number | string {
    let total = 0;
    props.data.forEach(row => {
      if (row[columnId]) {
        total += Number(row[columnId]);
      }
    });
    if (type === "currency") {
      return formatReportCurrency(total);
    } else {
      return total;
    }
  }

  function getRowCount() {
    return `Count: ${props.data.length}`;
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      rowClassNames={rowClassNames}
      footerData={footerData}
      expanding={true}
      expandingColumn="title"
    />
  );
}
